module.exports = __webpack_public_path__ + "static/img/file_go.690858d1.png";